const HEX_COLOR_PATTERN = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;

export function withAlpha(hexColor: string, alpha: number): string {
  const match = HEX_COLOR_PATTERN.exec(hexColor);
  if (!match) {
    throw new Error(`withAlpha expects a six digit hex color like "#ff4d38" but received "${hexColor}".`);
  }
  const [, red, green, blue] = match;
  return `rgba(${parseInt(red, 16)}, ${parseInt(green, 16)}, ${parseInt(blue, 16)}, ${alpha})`;
}
